<a class="navbar-brand light" routerLink="/" *transloco="let t">
    <img src="/assets/img/logo.svg" width="28" height="28" class="d-inline-block align-top" [alt]="t('header.title')"
        style="margin-right: 8px !important;">
    <span class="navbar-text">{{ t('header.title') }}</span>
    <span class="navbar-text-middle" [title]="t('header.title')">{{ t('header.titleMiddle') }}</span>
    <span class="navbar-text-mobile" [title]="t('header.title')">{{ t('header.titleMobile') }}</span>
    <span class="navbar-text-mobile-mini" [title]="t('header.title')">{{ t('header.titleMobileMini') }}</span>
</a>